import { selectJBPSettingsCurrentFYear } from 'legacy/lut/features/partner360/jbpSettings'
import { createSelector } from 'reselect'

import { selectBusinessPrioritiesState } from './selectBusinessPrioritiesState'

export const selectBusinessPrioritiesSelectedFYear = createSelector(
  [selectBusinessPrioritiesState, selectJBPSettingsCurrentFYear],
  (state, currentFYear) => state.selectedFYear ?? currentFYear
)
